todays-deliveries-checkbox
  .checkbox-fade.fade-in-primary
    label
      input(class="{opts.checkbox_class}" type="checkbox" value="{opts.riotValue}" name="taskable_ids[]" checked="checked")
      span.cr
        i.cr-icon.icofont.icofont-ui-check.txt-primary
  script(type="typescript").
    this.mixin('inputs.checkbox-fade-in')
  style(scoped).
    :scope {
      display: inline-block;
    }
    .checkbox-fade .cr, .checkbox-zoom .cr {
      margin-right: 0;
      float: none;
    }
    .checkbox-fade, .checkbox-zoom {
      margin-right: 0;
    }
    label {
      margin-bottom: 0;
    }
